import { Link } from "react-router-dom";
import useDetectKeelMind from "../../hooks/useDetectKeelMind";
function MindPageLink(props) {
    const isKeelMind = useDetectKeelMind(true);
    function getDestination() {
        return isKeelMind ? props.href.replace("/mind", "") : props.href;
    }
    return <Link {...props} to={getDestination()} />;
}

export default MindPageLink;
